var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"document-editor"},[_c('div',{staticClass:"document-editor__header"},[_c('div',{staticClass:"document-title-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sectionTitle),expression:"sectionTitle"}],staticClass:"document-editor__title",attrs:{"placeholder":"Enter Section Title","contenteditable":""},domProps:{"value":(_vm.sectionTitle)},on:{"input":function($event){if($event.target.composing)return;_vm.sectionTitle=$event.target.value}}}),_c('p',{staticClass:"document-title-label"},[_vm._v("The section title is only visible within the sidebar and is used for navigation purposes.")])]),_c('div',[_c('button',{staticClass:"back-btn",on:{"click":function($event){return _vm.backToDocument()}}},[_vm._v("Back to document")]),_c('button',{staticClass:"save-btn",on:{"click":function($event){return _vm.handleSave()}}},[_vm._v("Save")])])]),_c('div',{staticClass:"document-guidance-container"}),_c('tinymce-editor',{attrs:{"api-key":"rgwuelv76ygmvst2r951kalhen9s0yy7irpy5we625xig9ca","init":{
        menubar: false,
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
          'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
          'insertdatetime', 'media', 'table', 'help', 'wordcount', 'paste'
        ],
        toolbar: [
          'undo redo | styles | formatselect | bold italic underline strikethrough | forecolor backcolor',
          'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent',
          'table link | removeformat fullscreen code | customInsertButton | customGuidanceButton | customGuidanceButtonEnd'
        ].join(' | '),
        paste_as_text: true,
        paste_remove_styles: true,
        height: 600,
        content_style: [
          `
          ol.legal-numbering {
            counter-reset: item;
            list-style: none;
            padding-left: 1.5em;
          }
          .guidance {
            background-color: #00158A;
            border-radius: 8px;
            color: #fff;
            padding: 12px;
          }
          `
        ],
        style_formats: [
          {
            title: 'Legal Numbering',
            block: 'ol',
            classes: 'legal-numbering'
          }
        ],
        setup: function (editor) {
        editor.ui.registry.addButton('customInsertButton', {
          text: 'Add Image',
          icon: 'image',
          tooltip: 'Insert an image from the media library',
          onAction: () => {
            _vm.openMediaLibrary();
          }
        });
        editor.ui.registry.addButton('customGuidanceButton', {
          text: 'Start Guidance',
          icon: 'comment',
          tooltip: 'Turn highlighted text into guidance.',
          onAction: () => {
            const selectedContent = editor.selection.getContent()
            editor.insertContent(`<div class='guidance'>${selectedContent}</div>`)
          }
        });
        editor.ui.registry.addButton('customGuidanceButtonEnd', {
          text: 'End Guidance',
          icon: 'comment',
          tooltip: 'Turn off highlighted guidance section',
          onAction: () => {
          const currentContent = editor.getContent();
          const updatedContent = `${currentContent}<p>continue typing here...</p>`;
          editor.setContent(updatedContent);
          }
        });


        _vm.editorInstance = editor;
      }
      }},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}}),(_vm.showImageUploader)?_c('div',{staticClass:"image-uploader-container"},[_c('div',[_c('ImageUploader',{attrs:{"title":'Image',"widthOptionEnabled":false,"documentEditorUploader":true,"desc":'<p>We reccomend not using text in sections that contain an image.</p>'}}),_c('div',{staticClass:"image-uploader-icon-container"},[_c('button',{staticClass:"btn-cancel",on:{"click":function($event){_vm.showImageUploader = false}}},[_vm._v(" Cancel ")]),_c('button',{staticClass:"btn-add",on:{"click":function($event){return _vm.addImage()}}},[_vm._v("Add")])])],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }